export const WEB = 'web';
export const AGENCY_LINK = 'agencyLink';
export const AGENCY_SELECT = 'agencySelect';
export const AGENCY_SIGNON = 'agencySignon';
export const PARTNER = 'partner';
